import UserService from '@/api/user-service';
import { FETCH_USER } from './actions.type';
import { LOADING, SET_USER } from './mutations.type';

export default {
  [FETCH_USER](context) {
    context.commit(LOADING, true);
    return UserService.getUser()
      .then((response) => {
        context.commit(SET_USER, response.data);
      })
      .finally(() => {
        context.commit(LOADING, false);
      });
  },
};
